// libs
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
// types
import { Modals } from 'constants/modals'
import { Reducers } from 'store/types'
import { ModalsState } from 'store/reducers/modals/types'
// constants
import { ModalsInitialState } from 'store/reducers/modals/constants'

type ModalData = {
  isOpen: boolean
} & any

interface ShowModalPayload {
  modalType: Modals
  modalData?: ModalData
}

interface UpdateModalDataPayload {
  modalType: Modals
  modalData: ModalData
}

const initialState: Partial<ModalsState> = ModalsInitialState

export const modalsSlice = createSlice({
  name: Reducers.MODALS,
  initialState,
  reducers: (create) => ({
    showModal: create.reducer((state, action: PayloadAction<ShowModalPayload>) => {
      const { modalType, modalData } = action.payload

      state[modalType] = {
        ...modalData,
        isOpen: true
      }
    }),
    hideModal: create.reducer((state, action: PayloadAction<Modals>) => {
      if (state[action.payload]?.isOpen) {
        state[action.payload].isOpen = false
      }
    }),
    updateModalData: create.reducer((state, action: PayloadAction<UpdateModalDataPayload>) => {
      const { modalType, modalData } = action.payload

      state[modalType] = {
        ...state[modalType],
        ...modalData
      }
    })
  })
})

export const { showModal, hideModal, updateModalData } = modalsSlice.actions

export default modalsSlice.reducer
